import {UseFormReturn} from 'react-hook-form'

import {BrickCalculationPattern} from './BrickCalculationPattern'
import {BrickCalculationRatio} from './BrickCalculationRatio'
import {BrickCalculationSectionTable} from './BrickCalculationSectionTable'

import {
  BrickCalculationSectionDTO,
  EditMaterialInstallationForm
} from '@refra/modules/refra-planning/types'

interface BrickCalculationSectionProps {
  section: BrickCalculationSectionDTO
  brickShape1: string
  brickShape2: string
  sectionIndex: number
  formMethods: UseFormReturn<EditMaterialInstallationForm>
  isReadOnly?: boolean
}

export const BrickCalculationSection = ({
  section,
  brickShape2,
  brickShape1,
  sectionIndex,
  formMethods,
  isReadOnly
}: BrickCalculationSectionProps) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-row gap-2 justify-between">
        <BrickCalculationRatio
          brickShape1={brickShape1}
          brickShape2={brickShape2}
          mixingRatio={section.mixingRatio}
        />
        <BrickCalculationPattern brickShape1={brickShape1} layingPattern={section.layingPattern} />
      </div>
      <BrickCalculationSectionTable
        section={section}
        sectionIndex={sectionIndex}
        formMethods={formMethods}
        isReadOnly={isReadOnly}
      />
    </div>
  )
}
